import dynamic from 'next/dynamic';
import Head from "next/head";
import React from "react";

const TradeDetails =  dynamic(() => import('../../components/TradeDetails'), {
	ssr: false,
});
export default function Swap({ query: { hash } }) {
	return (
		<>
			<Head>
				<meta property="og:image" content={`https://stuff.mayan.finance/thumbnail_v2/explorer/${hash}.png`} key="ogtagimage"  />
				<meta property="twitter:image" content={`https://stuff.mayan.finance/thumbnail_v2/explorer/${hash}.png`} key="twittertagimage"  />
			</Head>
			<TradeDetails />
		</>
	)
}

Swap.getInitialProps = async ({ query }) => {
	return {
		query,
	};
}
